export { default as Flag } from './Flag';



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/Flag/index.ts